import type { RecordState } from "./clientApi";

export interface ClientInventory {
  active: number;
  archived: number;
}

export interface ClientCollectionComposition {
  isVirgin: boolean;
  showDiscovery: boolean;
  showEmptyAction: boolean;
  showHeaderAction: boolean;
  showRegisterStructure: boolean;
}

export function clientCollectionComposition(inventory: ClientInventory | null): ClientCollectionComposition {
  const isVirgin = inventory?.active === 0 && inventory.archived === 0;
  return {
    isVirgin,
    showDiscovery: !isVirgin,
    showEmptyAction: isVirgin,
    showHeaderAction: !isVirgin,
    showRegisterStructure: !isVirgin,
  };
}

export function updateClientInventory(
  inventory: ClientInventory | null,
  from: RecordState,
  to: RecordState,
): ClientInventory | null {
  if (!inventory) return inventory;
  return {
    ...inventory,
    [from]: Math.max(0, inventory[from] - 1),
    [to]: inventory[to] + 1,
  };
}

export function clientRecordPath(clientId: string) {
  return `/clients/${clientId}`;
}
